(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["info-tooltip"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.info-tooltip__btn');
    var tooltips = document.querySelectorAll('.info-tooltip');

    if (btn) {
      var tooltip = btn.closest('.info-tooltip');
      var isOpen = tooltip.classList.contains('open');
      tooltips.forEach(function (el) {
        el.classList.remove('open');
        var b = el.querySelector('.info-tooltip__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        tooltip.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
      e.stopPropagation();
    } else if (!e.target.closest('.info-tooltip__content')) {
      tooltips.forEach(function (el) {
        el.classList.remove('open');
        var b = el.querySelector('.info-tooltip__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card--bubble"] && !Shopify.designMode) return;
  try {
    const cards = document.querySelectorAll(".portrait-formats .product-card--custom");
  const formatsWrapper = document.querySelector(".portrait-formats");

  cards.forEach(card => {
    card.addEventListener("mouseover", () => {
      formatsWrapper.classList.add("hovered");
    });

    card.addEventListener("mouseout", () => {
      formatsWrapper.classList.remove("hovered");
    });

    card.style.width = card.querySelector(".product-title div > :is(p, span, h1, h2, h3, h4, h5, h6)").offsetWidth + 24 + "px";

    const handle = card.dataset.productHandle;
    if (handle) {
      const portraitProductDefaults = {
        "framed-canvas-1": {
          category: "canvas",
          size: "33 × 43 cm | 13.0 × 16.9 in",
          framing: "framed",
          color: "black",
        },
        "canvas-framed": {
          category: "canvas",
          size: "33 × 43 cm | 13.0 × 16.9 in",
          framing: "framed",
          color: "black",
        },
        "unframed-canvas": {
          category: "canvas",
          size: "30 × 40 cm | 11.8 × 15.7 in",
          framing: "unframed",
        },
        "canvas-unframed": {
          category: "canvas",
          size: "30 × 40 cm | 11.8 × 15.7 in",
          framing: "unframed",
        },
        "framed-poster": {
          category: "paper",
          size: "33 × 43 cm | 13.0 × 16.9 in",
          border: "no-border",
          color: "black",
        },
        "fine-art-paper-framed": {
          category: "paper",
          size: "33 × 43 cm | 13.0 × 16.9 in",
          border: "no-border",
          color: "black",
        },
        "fine-art-paper-unframed": {
          category: "paper",
          size: "21 × 30 cm | 8.3 × 11.8 in",
          framing: "unframed",
          border: "no-border",
        },
      };
      const defaultParams = portraitProductDefaults[handle];
      if (!defaultParams) return;

      const params = new URLSearchParams({
        style: "the_gentleman",
        step: "3",
        ...defaultParams,
      });
      const configuratorUrl = "/pages/portrait?" + params.toString();
      card.querySelectorAll("a.card-gallery__link, a.card-gallery__slide-link, .card-gallery a").forEach(link => {
        link.href = configuratorUrl;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card--floating"] && !Shopify.designMode) return;
  try {
    const floatingCards = document.querySelectorAll(".product-card--floating");
  const floatingImageswrapper = document.querySelector(".floating-images");

  floatingCards.forEach(card => {
    card.addEventListener("mouseover", () => {
      floatingImageswrapper.classList.add("hovered");
    });

    card.addEventListener("mouseout", () => {
      floatingImageswrapper.classList.remove("hovered");
    });
  });
  } catch(e) { console.error(e); }
})();

})();
